import React, { useContext } from "react";
import { FileParameter, useProjectApi } from "~/api/GeneratedApi";
import { InSeaHubContext } from "~/signalr/InSeaHubProvider";
import { useSignalrRApiResponseHandler } from "~/signalr/useSignalrRApiResponseHandler";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";

const wPRGenerationComplete = "WPRGenerationComplete";

export const useLatestWpr = () => {
  // const [wprGenerated, setWprGenerated] = React.useState<number>(0);
  const [projectIdState, setProjectIdState] = React.useState<
    number | undefined
  >();
  // const [latestWpr, setLatestWpr] = React.useState<FileResponse | undefined>();

  const { getLatestWPR, uploadWPR } = useProjectApi();

  const { data: wprFile } = useCustomQuery(
    { key: "latest-WPR", id: projectIdState },
    () => getLatestWPR(projectIdState as number),
    { enabled: projectIdState !== undefined },
  );

  const { connection, connected } = useContext(InSeaHubContext);
  useSignalrRApiResponseHandler({
    connected,
    connection,
    listenerKey: wPRGenerationComplete,
    successFunction: setProjectIdState,
  });

  //   React.useEffect(() => {
  //     if (!projectIdState) return;
  //     const fetchData = async () => {
  //       const response = await getLatestWPR(projectIdState);
  //       console.log(response.headers);
  //       setLatestWpr(response);
  //     };
  //     void fetchData();
  //   }, [getLatestWPR, projectIdState]);

  //   React.useEffect(() => {
  //     if (!projectIdState) return;
  //     const fetchData = async () => {
  //       const response = await fetch(
  //         "https://localhost:5001/api/Project/1878/wpr/latest",
  //         {
  //           headers: {
  //             Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6Ii1LSTNROW5OUjdiUm9meG1lWm9YcWJIWkdldyJ9.eyJhdWQiOiIxZTZmZTU5Mi03MDc5LTQwYzUtYmI5Yi02MmExNmZjMWNlOWMiLCJpc3MiOiJodHRwczovL2xvZ2luLm1pY3Jvc29mdG9ubGluZS5jb20vMzYxMDhkMDUtY2QyNC00NTE2LThiMDQtNjk0ZDdiODkzZDE3L3YyLjAiLCJpYXQiOjE2NzI3Mzg1NzcsIm5iZiI6MTY3MjczODU3NywiZXhwIjoxNjcyNzQzMTA4LCJhaW8iOiJBWFFBaS84VEFBQUFGWkN3WWg0SGdXWEgwcExHa3JLL3psdk5HL1BUb0JUejk4OTlpeXhrTWI4ZkZlcWNtaklvejZlWlMyQ0I5OGhERHMzL2hCUDY0QVNkaEYvakdaYXVQL1M3dDFkTHZTbGhhRzY4WFpNaVQwWG44UGY1NHlSTmpkUHNsd1lZRU81OExXT3FrRHZpZTJtOEptZ2FwVDRvL2c9PSIsImF6cCI6IjFlNmZlNTkyLTcwNzktNDBjNS1iYjliLTYyYTE2ZmMxY2U5YyIsImF6cGFjciI6IjAiLCJpZHAiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8zMGJjYWY3Ny01YjZlLTRjOWQtYWM1NC1lMzFhZDBjMGM3ZjQvIiwibmFtZSI6IkVsbWVyIFR1dWtrYW5lbiIsIm9pZCI6ImE1NzkwZGMwLWE5ZTQtNGNkOS1iZjcyLTNhOTgwODUxZTNiNiIsInByZWZlcnJlZF91c2VybmFtZSI6ImVsbWVyLnR1dWtrYW5lbkBub2Rlb24uY29tIiwicmgiOiIwLkFTTUFCWTBRTmlUTkZrV0xCR2xOZTRrOUY1TGxieDU1Y01WQXU1dGlvV19CenB3akFHOC4iLCJzY3AiOiIuNjc4ZmIwMWUtYmMzYS00ZDY1LWIwYTMtZGQ2OGI5MmNiODZlIiwic3ViIjoicE5LOTRyeDItNTJVOW5XQTlRUG9CTE5QaF9KTTd3dndJLWxzRkdFMklWZyIsInRpZCI6IjM2MTA4ZDA1LWNkMjQtNDUxNi04YjA0LTY5NGQ3Yjg5M2QxNyIsInV0aSI6ImJlWURzMFVsdVV1bG55OG9xUVEzQUEiLCJ2ZXIiOiIyLjAifQ.L-40xghVxN8kHYEHMc9tQYAOrxHmXgWMUDDW0fM6DhqrgV6VmvTJ37Amrv4lXb0EOobxOtBOT1CZ8XeUAWCQ1z3qaTJz-uZVgBLU-PLImSqybZHEajkYbseFDEYn7ARc6IGJJuQrqcKmoRO2QF4igfIwrMq_-yNLses4FBYGdf1jzqdAO5Rm1Js8ilf43H9E7ksdmTPT2tXNmvJfWm8g-gLsddhlA-qwnRDciAE_xBiNfKksLjtfFDGOqaaJpXbnyBGgdTxfsOMd8m-vJLmLm2di0scg0StaKFlhFJzoMVQzOFIoOS_3NDP3o71qz_4nMOFlr-2vtgc4JSvL9OpCsw`,
  //             Accept: "text/plain",
  //             "Accept-Language": "en-US,en;q=0.7,fi;q=0.3",
  //             "Accept-Encoding": "gzip, deflate, br",

  //             DNT: "1",
  //             // Connection: keep-alive,
  //             "Sec-Fetch-Dest": "empty",
  //             "Sec-Fetch-Mode": "cors",
  //             "Sec-Fetch-Site": "same-origin",
  //           },
  //         },
  //       );
  //       console.log(response);
  //       const blob = await response.blob();
  //       console.log("GAHLALALAGLGA");
  //       console.log(response.headers);
  //       console.log("444");
  //       console.log(blob);
  //     };
  //     void fetchData();
  //   }, [getLatestWPR, projectIdState]);

  const { mutateAsync: uploadModifiedWpr } = useCustomMutation(
    ({
      projectId,
      file,
    }: {
      projectId: number;
      file: FileParameter | null | undefined;
    }) => uploadWPR(projectId, file),
  );

  const wprFileUrl = React.useMemo(() => {
    if (!wprFile) return null;

    return URL.createObjectURL(wprFile.data);
  }, [wprFile]);

  const fileName = React.useMemo(() => {
    if (!wprFile) return "";

    const contentDisposition = wprFile.headers?.[
      "content-disposition"
    ] as string;
    if (!contentDisposition) return "TemplateFileName";
    return (
      contentDisposition.split("filename=")[1].split(";")[0] ??
      "contentdispFail"
    );
  }, [wprFile]);

  return { wprFile, wprFileUrl, fileName, uploadModifiedWpr };
};
